import React from "react"
import { Common } from "lib/types"
import { ReactComponent as ProductIcon } from "images/icons/bags-shopping.svg"
import { PermissionGroups } from "../constants"

import { Products } from "views/Products/Products"
import { ShowProducts } from "views/Products/ShowProducts"
import { ViewProduct } from "views/Products/ViewProduct"

export const productRoutes: Common.Views = [
  {
    element: <Products />,
    path: "/products",
    title: "Products",
    icon: ProductIcon,
    sortOrder: 5,
    requiredGroups: PermissionGroups.products.read,
    children: [
      {
        element: <ShowProducts />,
        path: "/products/",
        title: "Products",
        icon: ProductIcon
      },
      {
        element: <ViewProduct />,
        path: "/products/:id",
        title: "Product",
        parentPath: "/products"
      }
    ]
  }
]
